import { apiClient } from '@api/client';
import type {
  Feature,
  FeatureCreatePayload,
  FeatureUpdatePayload,
  FeatureMatrixResponse,
  FeatureToggleRequest,
} from '@/types/features';

export async function fetchFeatureMatrix() {
  const { data } = await apiClient.get<FeatureMatrixResponse>('/crm/features/matrix');
  return data;
}

export async function toggleFeatureMapping(body: FeatureToggleRequest) {
  const { data } = await apiClient.post<{ ok: boolean }>('/crm/features/matrix/toggle', body);
  return data;
}

export async function fetchFeaturesCatalog() {
  const { data } = await apiClient.get<Feature[]>('/crm/features');
  return data;
}

export async function createFeature(body: FeatureCreatePayload) {
  const { data } = await apiClient.post<Feature>('/crm/features', body);
  return data;
}

export async function updateFeature(key: string, body: FeatureUpdatePayload) {
  const { data } = await apiClient.patch<Feature>(`/crm/features/${key}`, body);
  return data;
}
